import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { canAccessTool, canAccessToolsHub, getToolMeta } from '../../config/toolAccess';
import { recordToolVisit } from '../../utils/recordToolVisit';
import AccessDenied from './AccessDenied';

export default function ToolRoute({ toolKey, toolKeys, hub, children }) {
  const { user } = useAuth();
  const location = useLocation();
  const keys = toolKeys || (toolKey ? [toolKey] : []);
  const ok = hub
    ? canAccessToolsHub(user?.role)
    : keys.some((k) => canAccessTool(user?.role, k));

  useEffect(() => {
    if (!ok || !user) return;

    if (hub) {
      recordToolVisit({ toolKey: 'tools-hub', name: 'Tools', path: '/tools' });
      return;
    }

    const key = keys[0];
    if (!key) return;

    const meta = getToolMeta(key);
    recordToolVisit({
      toolKey: key,
      name: meta?.name || key,
      path: location.pathname,
    });
  }, [location.pathname, ok, user, hub, keys.join(',')]);

  if (!ok) return <AccessDenied what="use this tool" />;
  return children;
}
